

















































































































































































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import TenantpaidDetailBase from "./TenantpaidDetailBase";

	@Component
	export default class TenantpaidDetail extends TenantpaidDetailBase {

	 	 	
		created() {
			this.returnRoute = "";
            super.initializeRights('COR_Setting_Tenant', 'COR_Setting_Tenant', 'COR_Setting_Tenant', 'COR_Setting_Tenant');
			super.setMainDescription('tenantpaid.detail', 'tenantpaid.detail');
            this.mainDataChanged = false;
            this.formIsInEditMode = false;
            this.styleFormDetail = true;
            this.createdBase();
		}

        changeCheckbox(item: any, item2: any, item3: any, item4: any) {
            this.changeCheckboxBase(item, item2, item3, item4);
        }       

        preventRefresh(event: any) {
            if (this.$store.state.askBeforeCancelEditing === true && this.formIsInEditMode && this.dataWasChanged()) {
                event.preventDefault(); event.returnValue = "";
            }
		}

        beforeMount() {
            window.addEventListener("beforeunload", this.preventRefresh);
        }

        selectFunction() {
            this.selectFunctionBase();
        }

        beforeDestroy() {
            window.removeEventListener("beforeunload", this.preventRefresh);
            this.$store.commit("formIsInEditMode", false);
            this.$store.commit("mainDataChanged", false);
        }

		mounted() {
			super.mounted();
		};

		validate() {
			return this.validateBase();
		}

		isCorrectName(value: any) {
			this.isCorrectNameBase(value);
		}		

        isCorrectMaturityDay(value: any) {
            this.isCorrectMaturityDayBase(value);
        }

        isCorrectUrgentDay(value: any) {
            this.isCorrectUrgentDayBase(value);
        }

        //slevy

        disableAddButton() {
            return false;
        }

        detailDiscount(item:any) {
            this.detailDiscountBase(item);
        }

        private deleteDiscount(item: any): void {
            this.deleteDiscountBase(item);
        }

        private addNewDiscount(): void {
            this.addNewDiscountBase();
        }

	}
